import React, { useState } from 'react';
import styled from 'styled-components';
import { useNavigate, useLocation } from 'react-router-dom';
import { IoChevronBack } from 'react-icons/io5';
import { FiTrash2, FiEdit3 } from 'react-icons/fi';
import TopNav from '../components/TopNav';
import { useNoobookContext } from '../context/NoobookContext';
import { useEffect } from 'react';
import { getBookcommunityBook, getBookcommunityBookComments, createBookcommunityBookComment, deleteBookcommunityBookComment, modifyBookcommunityBookComment } from '../api/BookcommunityApi';
import { getAccessToken } from '../react-queries/queries';
import { processApiResponse, ERROR_CODES } from '../common/errorMessage';
import LoadingOverlay from '../components/LoadingOverlay';
import MessageModal from '../components/MessageModal';
import { useUserInfoQuery } from '../react-queries/queries';
import BookListRegisterPage from './BookListRegisterPage';
import { FaTimes } from 'react-icons/fa';
import { communityType2text } from '../common/enums';
import BookCoverImage from '../components/BookCoverImage';

const Wrapper = styled.div`
  max-width: 480px;
  margin: 0 auto;
  background: #fff;
  min-height: 100vh;
`;

const Content = styled.div`
  padding: 0 0 50px 0;
`;

const BannerImg = styled.img`
  width: 100%;
  height: 180px;
  object-fit: cover;
  border-radius: 0;
  display: block;
`;

const ProfileRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 20px 20px 0 20px;
`;

const ProfileImg = styled.div`
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: #eaeaea;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  color: #bbb;
`;

const ProfileInfo = styled.div`
  flex: 1;
  padding-left: 0;
`;

const ProfileInfoRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 2px;
`;

const Nickname = styled.div`
  font-weight: bold;
  font-size: 1.1rem;
  color: #222;
`;

const UserId = styled.div`
  color: #888;
  font-size: 0.95rem;
`;

const Badge = styled.span`
  background: #e64980;
  color: #fff;
  font-size: 13px;
  border-radius: 4px;
  padding: 2px 4px;
  white-space: nowrap;
  display: inline-block;
  font-weight: 400;
  margin-left: 4px;
`;

const TagRow = styled.div`
  color: #888;
  font-size: 0.85rem;
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  margin-left: 0;
  margin-top: 0;
`;

// 탭 스타일
const TabRow = styled.div`
  display: flex;
  align-items: center;
  border-bottom: 1.5px solid #e0e0e0;
  background: #eae8e9;
  margin: 0;
`;

const Tab = styled.button`
  flex: 1;
  background: none;
  border: none;
  font-size: 17px;
  font-weight: 600;
  color: ${props => props.active ? '#222' : '#bdbdbd'};
  border-bottom: ${props => props.active ? '3px solid #222' : 'none'};
  padding: 14px 0 10px 0;
  cursor: pointer;
`;

const TabContent = styled.div`
  padding: 20px;
`;

const BookDescHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 24px 0 8px 0;
`;


const BookEditButton = styled.button`
  background: #1976d2;
  color: #fff;
  border: none;
  border-radius: 6px;
  padding: 6px 12px;
  font-size: 13px;
  cursor: pointer;
  transition: background-color 0.2s;
  
  &:hover {
    background: #1565c0;
  }
`;


const BookDescTitle = styled.div`
  font-size: 18px;
  font-weight: 600;
  color: #222;
  margin-bottom: 12px;
`;

const BookDesc = styled.div`
  font-size: 14px;
  color: #666;
  line-height: 1.6;
  margin-bottom: 24px;
`;

const BookInfoRow = styled.div`
  display: flex;
  gap: 16px;
  margin-bottom: 24px;
`;

const BookInfo = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 4px;
`;

const BookTitle = styled.div`
  font-size: 18px;
  font-weight: 600;
  color: #222;
  margin-bottom: 0px;
`;

const BookAuthor = styled.div`
  font-size: 14px;
  color: #666;
`;

const InfoTable = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  row-gap: 4px;
  column-gap: 10px;
  margin-top: 8px;
  align-items: center;
  font-size: 0.9rem;
  text-align: left;
`;

const InfoLabelBadge = styled.span`
  background: ${({ gray }) => (gray ? '#666' : '#1976d2')};
  color: #fff;
  font-size: 0.9rem;
  border-radius: 4px;
  padding: 2px 4px;
  white-space: nowrap;
  display: inline-block;
  font-weight: 400;
`;

const CommentInputContainer = styled.div`
  margin-top: 20px;
  padding: 16px 0;
`;

const CommentInputWrapper = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;

const CommentInput = styled.input`
  flex: 1;
  height: 36px;
  border: 1px solid #e1e1e1;
  border-radius: 18px;
  padding: 0 16px;
  font-size: 14px;
  background: #f7f7f7;
  box-sizing: border-box;
  
  &:focus {
    outline: none;
    border-color: #244AC2;
  }
`;

const CommentSubmitButton = styled.button`
  background: #888;
  color: white;
  border: none;
  border-radius: 16px;
  padding: 6px 12px;
  font-size: 12px;
  cursor: pointer;
  white-space: nowrap;
  
  &:hover {
    background: #666;
  }
  
  &:disabled {
    background: #ccc;
    cursor: not-allowed;
  }
`;

// 커뮤니티 서브 탭 스타일
const CommunitySubTabRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0 20px;
  padding: 4px 0 20px 0;
`;

const CommunitySubTab = styled.button`
  background: ${props => props.active ? '#333' : '#f5f5f5'};
  color: ${props => props.active ? '#fff' : '#666'};
  border: none;
  border-radius: 20px;
  padding: 6px 16px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
`;

const CommentsContainer = styled.div`
  margin-top: 16px;
`;

const CommentItem = styled.div`
  padding: 12px 0;
  border-bottom: 1px solid #f0f0f0;
  
  &:last-child {
    border-bottom: none;
  }
`;

const CommentHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 4px;
`;

const CommentAuthor = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: #222;
`;

const CommentDate = styled.div`
  font-size: 12px;
  color: #888;
`;

const CommentContent = styled.div`
  font-size: 14px;
  color: #333;
  line-height: 1.5;
`;

const DeleteButton = styled.button`
  background: none;
  border: none;
  color: #999;
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  
  &:hover {
    background: #f5f5f5;
    color: #e74c3c;
  }
`;

const LoadMoreButton = styled.button`
  width: 100%;
  padding: 12px;
  background: #f5f5f5;
  border: none;
  border-radius: 8px;
  color: #666;
  font-size: 14px;
  cursor: pointer;
  margin-top: 16px;
  
  &:hover {
    background: #e0e0e0;
  }
  
  &:disabled {
    background: #f9f9f9;
    color: #ccc;
    cursor: not-allowed;
  }
`;

const LoadingText = styled.div`
  text-align: center;
  color: #999;
  font-size: 14px;
  padding: 16px;
`;

// 댓글 수정 모달 스타일
const EditModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

const EditModalContent = styled.div`
  background: white;
  border-radius: 12px;
  padding: 24px;
  width: 90%;
  max-width: 400px;
  max-height: 80vh;
`;

const EditModalTitle = styled.h3`
  margin: 0 0 16px 0;
  font-size: 18px;
  font-weight: 600;
  color: #222;
`;

const EditTextarea = styled.textarea`
  width: 100%;
  min-height: 100px;
  border: 1px solid #e1e1e1;
  border-radius: 8px;
  padding: 12px;
  font-size: 14px;
  font-family: inherit;
  resize: vertical;
  box-sizing: border-box;
  
  &:focus {
    outline: none;
    border-color: #244AC2;
  }
`;

/*
const EditModalButtons = styled.div`
  display: flex;
  gap: 12px;
  margin-top: 16px;
`;

const EditModalButton = styled.button`
  flex: 1;
  padding: 12px;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  
  &.cancel {
    background: #f5f5f5;
    color: #666;
    
    &:hover {
      background: #e0e0e0;
    }
  }
  
  &.save {
    background: #244AC2;
    color: white;
    
    &:hover {
      background: #1e3a8a;
    }
    
    &:disabled {
      background: #ccc;
      cursor: not-allowed;
    }
  }
`;
*/


const EditModalButtons = styled.div`
  display: flex;
  gap: 12px;
  justify-content: center;
  padding: 20px;
  border-top: 1px solid #f0f0f0;
`;

const EditModalButton = styled.button`
  background: #eee;
  color: #555;
  border: none;
  border-radius: 8px;
  padding: 6px 18px;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
  min-width: 64px;
   &.cancel {
    background: #f5f5f5;
    color: #666;
    
    &:hover {
      background: #e0e0e0;
    }
  }
  
  &.save {
    background: #244AC2;
    color: white;
    
    &:hover {
      background: #1e3a8a;
    }
    
    &:disabled {
      background: #ccc;
      cursor: not-allowed;
    }
  }
`;






const EditButton = styled.button`
  background: none;
  border: none;
  color: #999;
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  
  &:hover {
    background: #f5f5f5;
    color: #244AC2;
  }
`;





const BookEditModal = styled.div`
  position: fixed;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  max-width: 480px;
  height: 100vh;
  background: #fff;
  z-index: 1000;
  display: flex;
  flex-direction: column;
`;

const BookEditModalHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 20px 16px 20px;
  border-bottom: 1px solid #eee;
  background: #fff;
`;

const BookEditModalTitle = styled.div`
  font-size: 20px;
  font-weight: 700;
  color: #222;
`;

const BookEditCloseButton = styled.button`
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #666;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: background-color 0.2s;
  
  &:hover {
    background: #f5f5f7;
  }
`;

const BookEditModalContent = styled.div`
  flex: 1;
  overflow-y: auto;
`;



// 상수 정의
const COMMENT_PAGE_SIZE = 10;


function useQuery() {
  return new URLSearchParams(useLocation().search);
}

export default function MoimDetailCommunityBookDetailPage({bookCommunityId, bookCommunityBookId, onModified}) {
  const navigate = useNavigate();
  const query = useQuery();
  const title = query.get('title');
  const { setShowBack, setLogoText } = useNoobookContext();
  const [activeTab, setActiveTab] = useState('community');
  const [communityTab, setCommunityTab] = useState('booklist');
  const [commentInput, setCommentInput] = useState('');
  const [comments, setComments] = useState([]);
  const [bookData, setBookData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const {data: userInfo} = useUserInfoQuery();
  
  // 댓글 관련 상태
  const [commentPage, setCommentPage] = useState(0);
  const [hasMoreComments, setHasMoreComments] = useState(true);
  const [loadingComments, setLoadingComments] = useState(false);
  const [loadingMoreComments, setLoadingMoreComments] = useState(false);
  
  // 댓글 수정 관련 상태
  const [editingComment, setEditingComment] = useState(null);
  const [editCommentText, setEditCommentText] = useState('');
  const [savingEdit, setSavingEdit] = useState(false);
  const [showBookEditModal, setShowBookEditModal] = useState(false);
  const [isBookModified, setIsBookModified] = useState(false);

  useEffect(() => {
    setShowBack(true);
    setLogoText('도서리스트 상세');
    return () => setShowBack(false);
  }, [setShowBack, setLogoText]);

  const loadBookData = async () => {
    if (!bookCommunityBookId) {
      setError('도서 ID가 없습니다.');
      return;
    }

    if (loading) {
      return;
    }

    try {
      setLoading(true);
      const { accessToken } = await getAccessToken();
      
      const response = await getBookcommunityBook(accessToken || '', bookCommunityBookId);
      const processedResponse = processApiResponse(response);
      
      if (processedResponse.success) {
        setBookData(processedResponse.data);
      } else {
        setError(processedResponse.errorMessage || '도서 정보를 불러오는데 실패했습니다.');
      }
    } catch (err) {
      console.error('도서 데이터 로드 중 오류:', err);
      setError('도서 정보를 불러오는데 실패했습니다.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (bookCommunityBookId) {
      loadBookData();
      loadComments(true); // 초기 댓글 로드
    }
  }, [bookCommunityBookId]);

  useEffect(() => {
    if(isBookModified) {
        loadBookData();
        setIsBookModified(false);
    }
  }, [isBookModified]);

  // 댓글 로드 함수
  const loadComments = async (reset = false) => {
    if (!bookCommunityBookId) return;
    
    const currentPage = reset ? 0 : commentPage;
    
    if (loadingComments || loadingMoreComments) return;
    
    try {
      if (reset) {
        setLoadingComments(true);
      } else {
        setLoadingMoreComments(true);
      }
      
      const { accessToken } = await getAccessToken();
      const response = await getBookcommunityBookComments(
        accessToken || '', 
        bookCommunityBookId, 
        currentPage, 
        COMMENT_PAGE_SIZE
      );
      
      const processedResponse = processApiResponse(response);
      
      if (processedResponse.success) {
        const newComments = processedResponse.data || [];
        
        if (reset) {
          setComments(newComments);
          setCommentPage(1);
        } else {
          setComments(prev => [...prev, ...newComments]);
          setCommentPage(prev => prev + 1);
        }
        
        // 더 이상 로드할 댓글이 없는지 확인
        setHasMoreComments(newComments.length === COMMENT_PAGE_SIZE);
      } else {
        console.error('댓글 로드 실패:', processedResponse.errorMessage);
      }
    } catch (err) {
      console.error('댓글 로드 중 오류:', err);
    } finally {
      setLoadingComments(false);
      setLoadingMoreComments(false);
    }
  };

  // 더 많은 댓글 로드
  const loadMoreComments = () => {
    if (hasMoreComments && !loadingMoreComments) {
      loadComments(false);
    }
  };


  const handleCommentSubmit = async () => {
    if (!commentInput.trim()) {
      setError('댓글을 입력해주세요.');
      return;
    }
    
    if (!bookCommunityBookId) {
      setError('도서 정보가 없습니다.');
      return;
    }
    
    try {
      const { accessToken } = await getAccessToken();
      const commentData = {
        memberId: null, // API에서 자동으로 현재 사용자 ID를 설정할 것으로 예상
        bookComment: commentInput.trim()
      };
      
      const response = await createBookcommunityBookComment(
        accessToken || '', 
        bookCommunityBookId, 
        commentData
      );
      
      const processedResponse = processApiResponse(response);
      
      if (processedResponse.success) {
        // 댓글 작성 성공 시 댓글 목록 새로고침
        if(onModified) {
          onModified(true);
        }
        setCommentInput('');
        loadComments(true);
      } else {
        setError(processedResponse.errorMessage || '댓글 작성에 실패했습니다.');
      }
    } catch (err) {
      console.error('댓글 작성 중 오류:', err);
      setError('댓글 작성에 실패했습니다.');
    }
  };

  const handleCommentKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleCommentSubmit();
    }
  };

  const handleDeleteComment = async (commentId) => {
    if (!window.confirm('댓글을 삭제하시겠습니까?')) {
      return;
    }
    
    try {
      const { accessToken } = await getAccessToken();
      const response = await deleteBookcommunityBookComment(
        accessToken || '', 
        commentId
      );
      
      const processedResponse = processApiResponse(response);
      
      if (processedResponse.success || response.errorCode === ERROR_CODES.NOTFOUND) {
        // 댓글 삭제 성공 시 댓글 목록 새로고침
        if(onModified) {
          onModified(true);
        }
        //loadComments(true);
        for(let i = 0; i < comments.length; i++) {
          if(comments[i].id === commentId) {
            comments.splice(i, 1);
            break;
          }
        }
        setComments([...comments]);
      } else {
        setError(processedResponse.errorMessage || '댓글 삭제에 실패했습니다.');
      }
    } catch (err) {
      console.error('댓글 삭제 중 오류:', err);
      setError('댓글 삭제에 실패했습니다.');
    }
  };


  const handleCloseErrorModal = () => {
    setError(null);
  };

  // 댓글 수정 모달 열기
  const handleEditComment = (comment) => {
    setEditingComment(comment);
    setEditCommentText(comment.bookComment || '');
  };

  // 댓글 수정 모달 닫기
  const handleCloseEditModal = () => {
    setEditingComment(null);
    setEditCommentText('');
    setSavingEdit(false);
  };

  // 댓글 수정 저장
  const handleSaveEdit = async () => {
    if (!editCommentText.trim()) {
      setError('댓글 내용을 입력해주세요.');
      return;
    }

    if (!editingComment) {
      setError('수정할 댓글 정보가 없습니다.');
      return;
    }

    try {
      setSavingEdit(true);
      const { accessToken } = await getAccessToken();
      
      const commentData = {
        memberId: editingComment.memberId,
        bookComment: editCommentText.trim()
      };
      
      const response = await modifyBookcommunityBookComment(
        accessToken || '', 
        editingComment.id, 
        commentData
      );
      
      const processedResponse = processApiResponse(response);
      
      if (processedResponse.success) {
        // 댓글 수정 성공 시 댓글 목록 새로고침
        if(onModified) {
          onModified(true);
        }
        editingComment.bookComment = editCommentText.trim();
        handleCloseEditModal();
        //loadComments(true);
      } else {
        setError(processedResponse.errorMessage || '댓글 수정에 실패했습니다.');
      }
    } catch (err) {
      console.error('댓글 수정 중 오류:', err);
      setError('댓글 수정에 실패했습니다.');
    } finally {
      setSavingEdit(false);
    }
  };


  const openBookEditModal = () => {
    setShowBookEditModal(true);
  };

  // 수정 모달 닫기
  const closeBookEditModal = (modified) => {
    setShowBookEditModal(false);
    if(modified) {
      setIsBookModified(true);
    }
  };


  const isOwner = bookData && userInfo && bookData.communityOwnerId === userInfo.id;

  // 로딩 중일 때
  if (loading || loadingComments || loadingMoreComments) {
    return (
      <Wrapper>
        <LoadingOverlay />
      </Wrapper>
    );
  }


  // 도서 데이터가 없을 때
  if (!bookData) {
    return (
      <Wrapper>
        <Content>
          <div style={{ padding: '20px', textAlign: 'center', color: '#666' }}>
            도서 정보를 찾을 수 없습니다.
          </div>
        </Content>
      </Wrapper>
    );
  }

  return (
    <Wrapper>
      <Content>
        <BannerImg src={bookData.communityImgUrl || "/book_sample.jpg"} alt="banner" />
        <TabContent>
        {/*<div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', height: '20px'}}></div> */}
            <BookDescHeader>
                <BookDescTitle>도서 소개</BookDescTitle>
                {isOwner && (
                    <BookEditButton onClick={openBookEditModal}>
                      수정
                    </BookEditButton>
                  )}
            </BookDescHeader>
                <BookDesc>
                  {bookData.bookIntroduction || '도서 소개가 없습니다.'}
                </BookDesc>
                
                <BookInfoRow>
                  <BookCoverImage
                    src={bookData.book?.cover}
                    alt={bookData.book?.title}
                    width={80}
                    height={120}
                    borderRadius={4}
                    boxShadow="none"
                    fontSize={10}
                  />
                  <BookInfo>
                    <BookTitle>{bookData.book?.title || '-'}</BookTitle>
                    <BookAuthor>{bookData.book?.author || '-'}</BookAuthor>
                    <InfoTable>
                      <InfoLabelBadge>참여일자</InfoLabelBadge><div>{bookData.meetingDate ? new Date(bookData.meetingDate).toLocaleDateString() : '-'}</div>
                      <InfoLabelBadge>참여시간</InfoLabelBadge><div>{bookData.meetingTime || '-'}</div>
                      <InfoLabelBadge>참여인원</InfoLabelBadge><div>{bookData.participantNum ? `${bookData.participantNum}명` : '-'}</div>
                      <InfoLabelBadge gray style={{textAlign: 'center'}}>참여형태</InfoLabelBadge><div>{communityType2text(bookData.meeting_type) || '-'}</div>
                    </InfoTable>
                  </BookInfo>
                </BookInfoRow>
                
                <BookDescTitle>참여조건</BookDescTitle>
                <BookDesc>{bookData.participationCondition || '-'}</BookDesc>
                
                <BookDescTitle>발제문</BookDescTitle>
                <BookDesc style={{whiteSpace: 'pre-line'}}>{bookData.presentationStatement || '-'}</BookDesc>
                
                {/* 댓글 입력창 */}
                <CommentInputContainer>
                  <CommentInputWrapper>
                    <CommentInput 
                      placeholder="답글을 입력해주세요"
                      value={commentInput}
                      onChange={(e) => setCommentInput(e.target.value)}
                      onKeyPress={handleCommentKeyPress}
                    />
                    <CommentSubmitButton onClick={handleCommentSubmit}>
                      작성
                    </CommentSubmitButton>
                  </CommentInputWrapper>
                </CommentInputContainer>
                
                {/* 댓글 목록 */}
                <CommentsContainer>
                  {comments.length > 0 ? (
                    <>
                      {comments.map((comment) => (
                        <CommentItem key={comment.id}>
                          <CommentHeader>
                            <div style={{display: 'flex', alignItems: 'center', gap: '8px'}}>
                              <CommentAuthor>{userInfo?.id === comment.memberId ? '나' : (comment.name || comment.loginid || '익명')}</CommentAuthor>
                              <CommentDate>
                                {comment.createdAt ? new Date(comment.createdAt).toLocaleDateString('ko-KR') : '-'}
                              </CommentDate>
                              {/* 현재 사용자가 작성한 댓글인지 확인하는 로직이 필요할 수 있음 */}
                              {((userInfo && userInfo?.id == bookData.communityOwnerId) || userInfo?.id === comment.memberId ) && (
                                <>
                                 {userInfo?.id === comment.memberId && (<EditButton onClick={(e) => {
                                    e.stopPropagation();
                                    handleEditComment(comment);
                                  }}>
                                    <FiEdit3 size={12} />
                                  </EditButton>)}
                                  <DeleteButton onClick={(e) => {
                                    e.stopPropagation();
                                    handleDeleteComment(comment.id);
                                  }}>
                                    <FiTrash2 size={12} />
                                  </DeleteButton>
                                </>
                              )}
                            </div>
                          </CommentHeader>
                          <CommentContent>{comment.bookComment}</CommentContent>
                        </CommentItem>
                      ))}
                      
                      {/* 더 보기 버튼 */}
                      {hasMoreComments && (
                        <LoadMoreButton 
                          onClick={loadMoreComments}
                          disabled={loadingMoreComments}
                        >
                          {loadingMoreComments ? '로딩 중...' : '더 보기'}
                        </LoadMoreButton>
                      )}
                    </>
                  ) : (
                    <LoadingText>아직 댓글이 없습니다.</LoadingText>
                  )}
                </CommentsContainer>
                </TabContent>
      </Content>
        <MessageModal
          isOpen={!!error}
          message={error}
          onClose={handleCloseErrorModal}
          title="오류"
        />
        {/* 도서 수정 모달 */}
        {showBookEditModal && (
        <BookEditModal>
          <BookEditModalHeader>
            <BookEditModalTitle>도서수정</BookEditModalTitle>
            <BookEditCloseButton onClick={()=>closeBookEditModal(false)}>
              <FaTimes />
            </BookEditCloseButton>
          </BookEditModalHeader>
          <BookEditModalContent>
            <BookListRegisterPage bookCommunityId={bookCommunityId} bookCommunityBookId={bookCommunityBookId} onClose={closeBookEditModal} />
          </BookEditModalContent>
        </BookEditModal>
        )}
        {/* 댓글 수정 모달 */}
        {editingComment && (
          <EditModalOverlay onClick={handleCloseEditModal}>
            <EditModalContent onClick={(e) => e.stopPropagation()}>
              <EditModalTitle>댓글 수정</EditModalTitle>
              <EditTextarea
                value={editCommentText}
                onChange={(e) => setEditCommentText(e.target.value)}
                placeholder="댓글을 입력해주세요"
                autoFocus
              />
              <EditModalButtons>
                <EditModalButton 
                  className="cancel" 
                  onClick={handleCloseEditModal}
                  disabled={savingEdit}
                >
                  취소
                </EditModalButton>
                <EditModalButton 
                  className="save" 
                  onClick={handleSaveEdit}
                  disabled={savingEdit || !editCommentText.trim()}
                >
                  {savingEdit ? '저장 중...' : '저장'}
                </EditModalButton>
              </EditModalButtons>
            </EditModalContent>
          </EditModalOverlay>
        )}
      </Wrapper>
    );
  }